import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.934.47.469 1.935 5.534 7 .469 12.065l1.465 1.465 5.065-5.065 5.065 5.065 1.465-1.465L8.464 7l5.065-5.065L12.064.47 7 5.535z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "times"}) } }